<h2 class="title">{{ title }}</h2>

<!-- Loading -->
<div *ngIf="dataSource.loading$ | async" class="loading-container">
  <mat-spinner></mat-spinner>
  <p>{{ "common.loading" | translate }}</p>
</div>

<!-- Search on tags -->
<div
  class="search-tags"
  *ngIf="(dataSource.loading$ | async) === false && ((filters.tags?.length ?? 0) > 0 || dataSource.getData().length > 0)"
>
  <app-search-risk-tags [selectedTags]="filters.tags ?? []" (selectedTagsChange)="onTagsChanged($event)"></app-search-risk-tags>
</div>

<!-- Empty state -->
<div class="empty-state" *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length === 0">
  <mat-icon class="empty-icon-small">science</mat-icon>
  <p class="empty-text">{{ "page.home.predispositions.empty" | translate }}</p>
</div>

<div *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length > 0">
  <div class="predisposition-grid">
    <app-predisposition *ngFor="let predisposition of dataSource.connect() | async" [predisposition]="predisposition"></app-predisposition>
  </div>

  <mat-paginator
    *ngIf="(dataSource.loading$ | async) === false && dataSource.getData().length !== totalCount"
    (page)="onPage($event)"
    [length]="totalCount"
    [pageSize]="filters.pageSize ?? 10"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="(filters.page ?? 1) - 1"
    [showFirstLastButtons]="true"
    class="predisposition-paginator"
    aria-label="Select page"
  ></mat-paginator>
</div>
